import { axiosPatientInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";

function useCreateEncounterIdentification(encounterId: string) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    ["createEncounterIdentification", { encounterId }],
    (input: FormData) =>
      axiosPatientInstance.post<string>(
        `v1/encounter/${encounterId}/form/files/identification`,
        input
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["encounterFormStatus", { encounterId }]);
      },
    }
  );
}

export { useCreateEncounterIdentification };
